import { Badge } from "./index";

const SEVERITY_COLORS: Record<string, "red" | "amber" | "blue" | "gray"> = {
  critical: "red",
  warning: "amber",
  info: "blue",
};

export default function SeverityBadge({ severity }: { severity: string }) {
  return (
    <Badge color={SEVERITY_COLORS[severity] ?? "gray"} dot>
      {severity}
    </Badge>
  );
}
